


































































































import { Component, Vue, Inject } from "vue-property-decorator";
import {
  ILeadProviderData,
  ILeadProviderMethods
} from "@/models/providers/lead";

@Component({
  components: {
    "lead-vessel": () => import("@/components/app/admin/leads/leadVessel.vue")
  }
})
export default class RelatedLeadsTable extends Vue {
  // Inject

  @Inject({ from: "leadProvider" })
  public readonly $leadProvider!: () => ILeadProviderData;

  @Inject({ from: "leadMethods" })
  public readonly $leadMethods!: ILeadProviderMethods;

  // Computed

  public get $leadData() {
    return this.$leadProvider();
  }

  public get lead() {
    return this.$leadData.lead;
  }
}
